import type { OnDestroy } from '@angular/core';
import { Component, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SpriLoadingBarComponent } from '@spri/components/loading-bar';
import { Subject } from 'rxjs';

@Component({
  selector: 'spri-empty-layout',
  templateUrl: './empty.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [SpriLoadingBarComponent, RouterOutlet],
})
export class EmptyLayoutComponent implements OnDestroy {
  private unsubscribeAll = new Subject<void>();

  /**
   * Constructor
   */

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.unsubscribeAll.next(null);
    this.unsubscribeAll.complete();
  }
}
